<template>
  <div class="register max-width">
    <div class="r_title font-30 fontweight-bo">找回密码</div>

    <div class="r_model" v-if="!bShowNext">
      <template v-for="(item, index) in r_list">
        <div :key="item.id" class="r_mod_line font-14">
          <div class="r_mod_li_name color-prompt-deep">{{ item.name }}：</div>
          <input
            :maxlength="item.maxlength"
            class="r_mod_li_value"
            :type="item.pass ? 'password' : ''"
            v-model="item.value"
          />
          <!-- 提示 -->
          <div
            v-if="index !== 'shoujiyanzheng'"
            class="r_mod_li_prompt font-12 color-prompt"
          >
            {{ item.prompt }}
          </div>
          <!-- 手机验证 -->
          <div v-else class="r_mod_li_validation no-copy">
            <!-- 未发送验证码 -->
            <div
              v-if="!isSendCode"
              :class="{
                'r_mod_li_vali_btn font-12': true,
                r_mod_li_vali_btn_isClick: isSendClick,
              }"
              @click="func_sendCode"
            >
              发送手机验证码
            </div>
            <!-- 已发送验证码(计时) -->
            <div v-else class="r_mod_li_vali_timing">
              已发送（{{ isSendTime }}s）
            </div>
          </div>
        </div>
      </template>
      <div class="r_mod_btn no-copy">
        <div
          class="r_mod_btn_submit bgcolor-gradient-right font-16 fontweight-bo"
          @click="func_submit"
        >
          确认修改
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ChangePassword,
  req_userInfo,
  SendRecoveryCode,
} from "@/services/user";
export default {
  name: "Retrieve",
  props: {},
  components: {},
  data() {
    return {
      bShowNext: false, //显示下一步窗口
      r_list: {
        shoujihaoma: {
          name: "手机号码",
          value: "",
          prompt: "可用于登录，请填写正确的手机号码",
          maxlength: 12,
        },
        shoujiyanzheng: {
          name: "短信验证",
          value: "",
          maxlength: 6,
        },
        shezhimima: {
          name: "新的登录密码",
          value: "",
          prompt: "",
          pass: true,
          maxlength: 12,
        },
        querenmima: {
          name: "确认登录密码",
          value: "",
          prompt: "",
          pass: true,
          maxlength: 12,
        },
      },
      isSendClick: false, //是否已点击发送验证码
      isSendCode: false, //是否已发送验证码
      isSendTime: 60, //验证码计时
      timerId: false,
      realSMS: -1, //接收到的短信验证码
      code: "",
    };
  },
  methods: {
    // 提交注册
    async func_submit() {
      const params = {
        phone: this.r_list["shoujihaoma"]["value"],
        newpassword: this.r_list["shezhimima"]["value"],
        oldpassword: this.r_list["querenmima"]["value"],
        code: this.r_list["shoujiyanzheng"]["value"],
      };
      if (!params.phone) {
        this.$parent.msgChange("fail", "请输入手机号", "");
        return;
      }
      if (!params.code) {
        this.$parent.msgChange("fail", "请输入验证码", "");
        return;
      }
      if (!params.newpassword) {
        this.$parent.msgChange("fail", "请设置登录密码", "");
        return;
      }
      if (!params.oldpassword) {
        this.$parent.msgChange("fail", "请确认登录密码", "");
        return;
      }
      if (params.newpassword !== params.oldpassword) {
        this.$parent.msgChange("fail", "两次密码输入不一致，请确认", "");
        return;
      }
      this.$parent.loadingChange(true, "提交中....");
      const result = await ChangePassword(
        params.phone,
        params.newpassword,
        params.code
      ); //修改密码
      this.$parent.loadingChange(false);
      if (result.success) {
        this.$parent.confirmChange(
          "success",
          "修改成功！请使用新密码登录！",
          () => {
            this.$router.push({
              name: "home",
            });
          },
          () => {},
          { yes: "去登录", no: "" }
        );
      } else {
        this.$parent.msgChange("fail", "修改失败", result.msg);
      }
    },
    // 发送验证码
    async func_sendCode() {
      if (
        this.r_list["shoujihaoma"]["value"] &&
        this.r_list["shoujihaoma"]["value"].length === 11
      ) {
        this.isSendClick = true;
        //请求发送验证码
        //生成验证码
        const result = await SendRecoveryCode(
          this.r_list["shoujihaoma"]["value"]
        );

        console.log(result);
        this.isSendClick = false;
        if (result.data["success"]) {
          //发送成功
          this.isSendCode = true;
          // 开始计时
          this.func_sendTime();
        } else if (result.data["success"] == false) {
          this.$parent.msgChange("warning", result.data.msg, "");
          //发送失败
          this.isSendCode = false;
        }
      } else {
        this.$parent.msgChange("warning", "请完善手机号码", "");
      }
    },
    func_sendTime() {
      this.timerId = setInterval(() => {
        if (this.isSendTime > 0) {
          this.isSendTime -= 1;
        } else {
          clearTimeout(this.timerId);
          this.isSendTime = 60;
          this.isSendCode = false;
        }
      }, 1000);
    },
    is_Email(str) {
      //判断是否邮箱格式
      var reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
      return reg.test(str);
    },
    is_Phone(str) {
      //判断是否手机号码
      var reg =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/;
      return reg.test(str);
    },
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.timerId);
  },
};
</script>
<style src='@/style/register.css' scoped></style>


// WEBPACK FOOTER //
// src/pages/Retrieve.vue